/* Recolor only the star bands in existing review artwork; image and copy stay intact. */
(function () {
  'use strict';
  var regions = {"lx-v4-05-review-joanne.webp":{"size":[2048,2048],"box":[231,691,853,794],"background":[254,254,254],"rating":5}};
  var ns = 'http://www.w3.org/2000/svg';
  function enhance(img) {
    if (img.dataset.hpReviewStars) return;
    var name = Object.keys(regions).find(function (key) { return (img.currentSrc || img.src || '').indexOf(key.replace(/\.webp$/, '')) !== -1; });
    if (!name) return;
    var spec = regions[name], parent = img.parentElement;
    if (!parent) return;
    img.dataset.hpReviewStars = 'true';
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + spec.size.join(' '));
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.classList.add('hp-review-image-stars');
    var box = spec.box, w = box[2] - box[0], h = box[3] - box[1];
    var cover = document.createElementNS(ns, 'rect');
    ['x', 'y', 'width', 'height'].forEach(function (attr, i) { cover.setAttribute(attr, [box[0], box[1], w, h][i]); });
    cover.setAttribute('fill', 'rgb(' + spec.background.join(',') + ')');
    svg.appendChild(cover);
    var step = w / 5, size = Math.min(step - 4, h - 4);
    for (var i = 0; i < 5; i++) {
      var star = document.createElementNS(ns, 'path');
      star.setAttribute('d', 'M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9l-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z');
      star.setAttribute('fill', '#F5C518');
      star.setAttribute('transform', 'translate(' + (box[0] + i * step + (step - size) / 2) + ' ' + (box[1] + (h - size) / 2) + ') scale(' + size / 20 + ')');
      svg.appendChild(star);
    }
    parent.appendChild(svg);
    function position() {
      var r = img.getBoundingClientRect(), p = parent.getBoundingClientRect();
      svg.style.left = (r.left - p.left + parent.scrollLeft - parent.clientLeft) + 'px';
      svg.style.top = (r.top - p.top + parent.scrollTop - parent.clientTop) + 'px';
      svg.style.width = r.width + 'px';
      svg.style.height = r.height + 'px';
    }
    img.addEventListener('load', position);
    if (window.ResizeObserver) new ResizeObserver(position).observe(img);
    else window.addEventListener('resize', position);
    position();
  }
  function scan() { document.querySelectorAll('img').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
}());
